import React from 'react';
import { Video } from 'lucide-react';
import { ChannelCallStatus } from '../types';

interface CallJoinBarProps {
  status: ChannelCallStatus;
  meId: string;
  /** 이 기기가 지금 다른 통화 중이다 — 참여 버튼을 막는다 */
  busy: boolean;
  onJoin: () => void;
}

/**
 * 대화방 헤더 아래 '통화 중 · 참여' 바 — 진행 중인 통화에 나중에 들어가는 유일한 길이다
 * (벨을 놓쳤거나 거절했거나 연결이 끊긴 사람). 데이터는 서버 call:status(App의 channelCalls).
 */
const CallJoinBar: React.FC<CallJoinBarProps> = ({ status, meId, busy, onJoin }) => {
  const people = status.participants || [];
  if (people.length === 0) return null;
  const inOtherDevice = people.some(p => String(p.userId) === String(meId));
  const max = status.max || 6;
  const full = people.length >= max;
  const first = people[0]?.userName || '참가자';
  const who = people.length > 1 ? `${first} 외 ${people.length - 1}명` : first;

  return (
    <div
      className="flex items-center gap-3 px-3 md:px-6 py-2 bg-emerald-50 border-b border-emerald-100 shrink-0"
      role="status"
    >
      <span className="relative flex w-7 h-7 shrink-0 items-center justify-center rounded-full bg-emerald-600 text-white">
        <Video size={14} />
      </span>
      <p className="flex-1 min-w-0 text-sm text-slate-800 truncate">
        <span className="font-semibold">통화 중</span>
        <span className="text-slate-600"> · {who}</span>
      </p>
      {inOtherDevice ? (
        <span className="shrink-0 text-xs text-slate-600">다른 기기에서 참여 중</span>
      ) : full ? (
        <span className="shrink-0 text-xs text-slate-600">인원이 가득 찼습니다(최대 {max}명)</span>
      ) : (
        <button
          type="button"
          onClick={onJoin}
          disabled={busy}
          title={busy ? '다른 통화 중에는 참여할 수 없습니다' : '이 통화에 참여'}
          className="shrink-0 h-8 px-4 rounded-full bg-brand-600 text-white text-sm font-medium hover:bg-brand-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-colors"
        >
          참여
        </button>
      )}
    </div>
  );
};

export default CallJoinBar;
